import React from "react"
import ReactApexChart from "react-apexcharts"

const LineColumnArea = () => {
  const series = [
    {
      name: "Tiempo promedio cursado",
      type: "column",
      data: [23, 11, 22, 27, 13],
    },
    {
      name: "Veces cursada promedio",
      type: "area",
      data: [44, 55, 41, 67, 22],
    },
  ]
  const options = {
    chart: {
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 2, 4],
      curve: "smooth",
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
    colors: ["#f46a6a", "#556ee6", "#34c38f"],

    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100],
      },
    },
    labels: [
      "Sistemas impermeables de poliuretano FesterSIP",
      "Nivelación de pisos a espesores gruesos",
      "Reparación estructural de concreto",
      "Impermeabilización de muros colindantes",
      "Acelerante de fraguado de concretos y morteros",
    ],
    markers: {
      size: 0,
    },
    legend: {
      offsetY: 11,
    },
    xaxis: {
      type: "text",
    },
    yaxis: {
      title: {
        text: "Veces",
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0)
          }
          return y
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      height="350"
    />
  )
}

export default LineColumnArea
